import React from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  Grid,
  FormControl,
  InputLabel,
  TextField,
  Button,
  Collapse,
  Autocomplete,
  Select,
  MenuItem,
  CircularProgress,
} from '@mui/material';

function findOption(options, value) {
  if (value === '' || value == null) return null;
  return (options || []).find((option) => String(option?.id) === String(value)) ?? null;
}

const IssueFilters = ({
  showFilters,
  filters,
  sort,
  usersList = [],
  statusOptions = [],
  statusFilterLoading = false,
  usersFilterLoading = false,
  onStatusOpen,
  onUsersOpen,
  onFilterChange,
  onSortChange,
  onClearFilters,
}) => {
  const statusList = Array.isArray(statusOptions) ? statusOptions : [];
  const userOptions = Array.isArray(usersList) ? usersList : [];

  return (
    <Collapse in={showFilters}>
      <Card sx={{ mb: 3 }}>
        <CardHeader
          title="Filters & Sorting"
          action={
            <Button onClick={onClearFilters} color="primary">
              Clear All
            </Button>
          }
        />
        <CardContent>
          <Grid container spacing={3}>
            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                label="Issue Title"
                value={filters.title}
                onChange={(e) => onFilterChange('title', e.target.value)}
              />
            </Grid>

            <Grid item xs={12} md={3}>
              <FormControl fullWidth>
                <InputLabel>Status</InputLabel>
                <Select
                  value={filters.status_id}
                  onChange={(e) => onFilterChange('status_id', e.target.value)}
                  onOpen={onStatusOpen}
                  label="Status"
                >
                  <MenuItem value="">All Statuses</MenuItem>
                  {statusFilterLoading && (
                    <MenuItem disabled value="__loading">
                      Loading…
                    </MenuItem>
                  )}
                  {statusList.map((status) => (
                    <MenuItem key={status.id} value={status.id}>
                      {status.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={3}>
              <FormControl fullWidth>
                <Autocomplete
                  value={findOption(userOptions, filters.author_id)}
                  onChange={(_, value) => onFilterChange('author_id', value ? value.id : '')}
                  onOpen={onUsersOpen}
                  loading={usersFilterLoading}
                  options={userOptions}
                  getOptionLabel={(option) => option.name || ''}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Created By"
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {usersFilterLoading ? (
                              <CircularProgress color="inherit" size={18} />
                            ) : null}
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                  isOptionEqualToValue={(option, value) =>
                    String(option?.id) === String(value?.id)
                  }
                  noOptionsText={usersFilterLoading ? 'Loading…' : 'No author found'}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} md={3}>
              <FormControl fullWidth>
                <InputLabel>Model Type</InputLabel>
                <Select
                  value={filters.model_type}
                  onChange={(e) => onFilterChange('model_type', e.target.value)}
                  label="Model Type"
                >
                  <MenuItem value="">All Types</MenuItem>
                  <MenuItem value="Lead">Lead</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <InputLabel>Sort By</InputLabel>
                <Select
                  value={sort.sort_by}
                  onChange={(e) => onSortChange({ ...sort, sort_by: e.target.value })}
                  label="Sort By"
                >
                  <MenuItem value="created_at">Created Date</MenuItem>
                  <MenuItem value="title">Issue Title</MenuItem>
                  <MenuItem value="updated_at">Last Updated</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <InputLabel>Sort Direction</InputLabel>
                <Select
                  value={sort.sort_direction}
                  onChange={(e) => onSortChange({ ...sort, sort_direction: e.target.value })}
                  label="Sort Direction"
                >
                  <MenuItem value="desc">Descending</MenuItem>
                  <MenuItem value="asc">Ascending</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Collapse>
  );
};

export default IssueFilters;
